// extracted by mini-css-extract-plugin
module.exports = {"login":"RqkpY","form":"z0mOx","field":"RtnMY","form-footer":"AI6PN","restore":"jFCPE","submit":"etS2x","message":"R1CNN","register":"g5IfZ","signupIcon":"HNnGD"};